module.exports = __webpack_public_path__ + "img/bj3.f2018d06.jpg";